import { BasePage as CngBasePage } from 'cng-web-lib'
import React from 'react'
import DataRestorePage from './DataRestorePage.js'
import useBreadcrumbNameMap from 'src/useBreadcrumbNameMap'

function WrappedDataRestorePage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <DataRestorePage showNotification={showSnackbar} {...props} />
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

export {
  WrappedDataRestorePage as DataRestorePage
}
